/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { type RefObject, useEffect, useRef } from 'react'

import { off, on } from '@lib/utils'

const defaultEvents = ['mousedown', 'touchstart']

export function useClickAway<E extends Event = Event>(
  ref: RefObject<HTMLElement | null>,
  onClickAway: (event: E) => void,
  events: string[] = defaultEvents
): void {
  const savedCallback = useRef(onClickAway)

  useEffect(() => {
    savedCallback.current = onClickAway
  }, [onClickAway])

  useEffect(() => {
    const handler = (event: any) => {
      const { current: el } = ref
      el && !el.contains(event.target) && savedCallback.current(event)
    }

    for (const eventName of events) {
      on(document, eventName, handler)
    }

    return () => {
      for (const eventName of events) {
        off(document, eventName, handler)
      }
    }
  }, [events, ref])
}
